// The build version at the foot of the sidebar, as a link that opens the Help
// menu on What's New (D-27). Built on the Button primitive's link variant so
// hover underline and focus ring come from the shared component; the inline
// style keeps today's small mono look.

import React from 'react';
import Button from './primitives/Button';

export default function BuildVersionLink({ version, onOpenWhatsNew }) {
    return (
        <Button
            variant="link"
            type="button"
            title="What's New"
            aria-label={`Build ${version}. Open What's New`}
            onClick={onOpenWhatsNew}
            style={{
                fontFamily: 'var(--font-mono)',
                fontSize: 10,
                letterSpacing: '0.02em',
                color: 'var(--sidebar-text-quiet)',
                padding: '4px 12px 2px',
                textAlign: 'left',
                justifyContent: 'flex-start',
            }}
        >
            Build {version}
        </Button>
    );
}
